import { datadogRum } from "@datadog/browser-rum"

import packageJson from "../../package.json"

const isDevelopment = process.env.NODE_ENV === "development"

const dataDogInit = () => {
    datadogRum.init({
        applicationId: '9a1449de-f4c3-4087-82a2-8f3e1e67a6b1',
        clientToken: 'pubfc61f57d35d7802b3dfb80eabd03d6fa',
        site: "us5.datadoghq.com",
        service: packageJson.name,
        env: window.VITE_APP_ENVIROMENT_NAME,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: packageJson.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "allow",
        beforeSend: () => {
            return !isDevelopment
        },
    })
}

export { dataDogInit, datadogRum }
